import React from 'react';

export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
};

interface InstallPromptModalProps {
  installPromptEvent: BeforeInstallPromptEvent | null;
  onDismiss: () => void;
  onInstall: () => void;
  isVisible: boolean;
}

export const InstallPromptModal: React.FC<InstallPromptModalProps> = ({
  installPromptEvent,
  onDismiss,
  onInstall,
  isVisible
}) => {
  if (!isVisible) return null;

  const canPrompt = !!installPromptEvent;

  return (
    <div className="modal-overlay">
      <div className="modal-content" role="dialog" aria-modal="true" aria-labelledby="install-modal-title">
        <div id="install-modal-title" className="section-title">
          Sebaiknya Terpasang di Layar Utama Handphone
        </div>
        <div className="subtitle">
          Supaya Adik dan orang tua bisa membuka latihan ini dengan satu ketukan.
        </div>

        {!canPrompt && (
           <div className="subtitle" style={{ color: 'var(--app-color-primary)', fontWeight: 500 }}>
             Buka menu browser lalu pilih “Tambahkan ke layar utama”
           </div>
        )}

        <div className="next-actions" style={{ flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
          {canPrompt && (
            <button
              type="button"
              className="btn-primary w-full"
              onClick={onInstall}
            >
              Pasang aplikasi
            </button>
          )}

          <button
            type="button"
            className="btn-secondary w-full"
            onClick={onDismiss}
          >
            {canPrompt ? 'Nanti saja' : 'Tutup'}
          </button>
        </div>
      </div>
    </div>
  );
};
